
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { transformPlayerData } from '@/utils/playerTransform';
import { Player } from '@/types/player';

export const useTeamPlayers = (teamId: string | null) => {
  const [players, setPlayers] = useState<Player[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchPlayers = useCallback(async () => {
    if (!teamId) {
      setPlayers([]);
      return;
    }

    try {
      setLoading(true);
      
      const { data, error } = await supabase
        .from('players')
        .select(`
          *,
          profile:profiles(first_name, last_name, email, is_verified)
        `)
        .eq('team_id', teamId);

      if (error) {
        console.error('Error fetching team players:', error);
        toast.error('Failed to load team players');
        return;
      }

      const transformedPlayers = (data || []).map(transformPlayerData);
      
      setPlayers(transformedPlayers);
    } catch (error) {
      console.error('Error fetching team players:', error);
      toast.error('Failed to load team players');
    } finally {
      setLoading(false);
    }
  }, [teamId]);

  useEffect(() => {
    fetchPlayers();
  }, [fetchPlayers]);

  return {
    players,
    loading,
    refetch: fetchPlayers
  };
};
